var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.128906,
    width: 46,
    height: 44,
    rx: 22,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.38 32.2978C27.188 32.2989 26.9977 32.2621 26.82 32.1895C26.6422 32.1169 26.4806 32.01 26.3442 31.8748L17.5912 23.1217C17.3195 22.8484 17.167 22.4786 17.167 22.0932C17.167 21.7078 17.3195 21.3381 17.5912 21.0648L26.3442 12.3117C26.6233 12.0727 26.9823 11.9478 27.3495 11.962C27.7166 11.9762 28.0649 12.1284 28.3247 12.3882C28.5845 12.648 28.7367 12.9963 28.7509 13.3635C28.7651 13.7306 28.6402 14.0896 28.4012 14.3687L20.684 22.0859L28.4012 29.8032C28.6061 30.0064 28.7461 30.2657 28.8035 30.5485C28.861 30.8312 28.8333 31.1247 28.724 31.3917C28.6147 31.6587 28.4287 31.8873 28.1894 32.0486C27.9502 32.2099 27.6685 32.2966 27.38 32.2978Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlack);
export default __webpack_public_path__ + "static/media/back_black.74d0c6b49f5aa7b314fd249f8670cccd.svg";
export { ForwardRef as ReactComponent };